export const DEPARTMENT_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'departments',
  // 対象テーブル
  TARGET_TABLE: 'department',
};
